import config from '../config';

const WIDGET_CONFIGS = {
    staging: {
        apiUrl: 'https://api-staging.playgolfhi.com',
        loaderUrl: 'https://s3-us-west-1.amazonaws.com/activiter-staging/widget/v1/loader.js'
    },
    live: {
        apiUrl: 'https://api.playgolfhi.com',
        loaderUrl: 'https://activiter-live.s3-us-west-1.amazonaws.com/widget/v1/loader.js'
    }
};

const widgetConfig = config.sentryEnv === 'staging' ? WIDGET_CONFIGS.staging : WIDGET_CONFIGS.live;

export const buildWidgetScript = (activityId, clientKey) =>
    `<div data-activiter-widget\n    data-client-key="${clientKey}"\n    data-activity-ids="${activityId}"\n    data-api-url="${widgetConfig.apiUrl}"\n    data-lang="en"\n></div>\n<script src="${widgetConfig.loaderUrl}"></script>`;
